import { getContrastingTextColor } from "../../util/ColorUtil";

export default function Badge({ status, type = "active", color = null }) {
  if (type == "active") {
    status = status ? "Active" : "Inactive";
  }

  let display, statusValue;
  if (typeof status === "string") {
    display = status;
    statusValue = status.toLowerCase().replace(" ", "-");
  } else if (status && typeof status === "object" && status.name) {
    display = status.name;
    statusValue = status.name.toLowerCase().replace(" ", "-");
    if (!color && status.color) {
      color = status.color;
    }
  } else {
    display = "No Status";
    statusValue = "no-status";
  }

  if (color) {
    return (
      <div
        className="badge"
        style={{
          backgroundColor: color,
          color: getContrastingTextColor(color),
        }}
      >
        {display || "-"}
      </div>
    );
  }

  return <div className={`badge ${type}-${statusValue}`}>{display || "-"}</div>;
}
